var map = {
	"./ds-dashboard-purchase-orders.component": 963,
	"./ds-dashboard-purchase-orders.component.js": 963,
	"./ds-invoice-confirmations.component": 957,
	"./ds-invoice-confirmations.component.js": 957,
	"./ds-invoice-export-management.component": 960,
	"./ds-invoice-export-management.component.js": 960,
	"./ds-invoice-header": 954,
	"./ds-invoice-header.js": 954,
	"./ds-invoice-histoy.component": 961,
	"./ds-invoice-histoy.component.js": 961,
	"./ds-invoice-related-documents-react": 958,
	"./ds-invoice-related-documents-react.js": 958,
	"./ds-invoice-rows": 959,
	"./ds-invoice-rows.js": 959,
	"./ds-invoice-slider.component": 962,
	"./ds-invoice-slider.component.js": 962,
	"./ds-legacy-error-notification.component": 967,
	"./ds-legacy-error-notification.component.js": 967,
	"./ds-main-menu": 956,
	"./ds-main-menu.js": 956,
	"./ds-pdf-file-viewer": 964,
	"./ds-pdf-file-viewer.js": 964,
	"./ds-rejected-invoices.component": 965,
	"./ds-rejected-invoices.component.js": 965,
	"./ds-survey-monkey": 966,
	"./ds-survey-monkey.js": 966,
	"./ds-top-menu": 955,
	"./ds-top-menu.js": 955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1424;